import styled from "styled-components";

export const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-right: 16px;
  padding: 6px 12px;
  border: 1px solid #040222;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
`;

export const HelpIconImage = styled.img`
  width: 16px;
  height: 16px;
  display: block;
`;

export const HelpLabel = styled.span`
  color: #040222;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
